<template>
    <NuxtLayout name="main">
        <module-navigations />

        <div :class="css.container">
            <ColumnLayout :class="css.content" class="container">
                <!-- * 统计结果 -->
                <div :class="css.statistics" class="font-variable" ref="container">
                    <template v-if="!keyword">{{ $t("Layout.PaginationStatistics", { count: count }) }}</template>
                    <i18n-t v-else scope="global" keypath="SearchResultPlaceholder">
                        <template v-slot:number>{{ count }}</template>
                        <template v-slot:keyword>
                            <span>{{ keyword }}</span>
                        </template>
                    </i18n-t>
                </div>

                <!-- * 表格 -->
                <SearchDiagram :class="css.table" v-on="ons.diagram" ref="table" :data="data" :option="option" :placeholder="$t('NoData')">
                    <template #noResult>
                        <div>
                            <i18n-t keypath="SearchNoResult" scope="global">
                                <template #keyword>
                                    <span :class="css.keyword" class="ellipsis">{{ keyword }}</span>
                                </template>
                            </i18n-t>
                        </div>
                    </template>

                    <template #name="{ data }">
                        <div :class="css.name">
                            <span :class="css.active" class="ellipsis" v-html="data.name"></span>
                            <ui-icon v-if="data.tag" :class="css.hot" name="hot" />
                        </div>
                    </template>

                    <template #gene="{ data }">
                        <div class="ellipsis" v-html="data.rel_gene_name"></div>
                    </template>

                    <template #alias="{ data }">
                        <div class="ellipsis">{{ data.alias }}</div>
                    </template>

                    <template #strain="{ data }">
                        <div class="ellipsis">{{ data.strain }}</div>
                    </template>

                    <template #disease="{ data }">
                        <div class="ellipsis">{{ data.related_disease }}</div>
                    </template>
                </SearchDiagram>

                <!-- * 分页器 -->
                <UiPagination v-if="count > 20" v-model="page" :count="count" :limit="20" @change="methods.data()">
                    <template #items> {{ $t("Layout.PaginationDetails", { count: count, limit: 20 }) }}</template>
                </UiPagination>

                <template #aside>
                    <!-- * 标题 -->
                    <DefaultName>{{ $route.meta.name ? $t($route.meta.name) : "" }}</DefaultName>
                    <!-- * 筛选器 -->
                    <div :class="css.selectors">
                        <div :class="css.selector" v-for="(value, key) in selector" :key="key">
                            <!-- * 全选按钮 -->
                            <ui-checkbox
                                :class="css.checkbox"
                                v-model="value.selector"
                                value=""
                                @change="methods.selectors(value)"
                                :title="value.name">
                                <div :class="css.name" class="font-bold font-variable color-1 ellipsis">{{ value.name }}</div>
                            </ui-checkbox>

                            <!-- * 单选项 -->
                            <UiCheckboxGroup :class="css.checkboxs" v-model="value.result" @change="methods.selector(value)">
                                <template v-for="(opt, index) in value.options" :key="index">
                                    <ui-checkbox :class="css.checkbox" :value="opt.value" :title="opt.label">
                                        <div class="ellipsis">{{ opt.label }}</div>
                                    </ui-checkbox>
                                </template>
                            </UiCheckboxGroup>
                        </div>
                    </div>
                </template>
            </ColumnLayout>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiCheckbox, UiPagination, UiCheckboxGroup, UiIcon } from "various-ui";
//* 公共组件
import { ColumnLayout, DefaultName } from "@/components/complete";
import { SearchDiagram } from "@/components/visualizations";
//* 私有公共组件
import ModuleNavigations from "../../components/navigations/index.vue";
//* 组件属性
import { useComposable } from "../src/composable";
import { useModelOption } from "../src/options";
//* 样式
import css from "../style/index.module.less";

//* 组合函数
const { ons, refs, nodes, watchs, methods } = useComposable("model");
const { container } = nodes;
const { data, page, count, exist, keyword, selector } = refs;

//* 配置项
const option = useModelOption();

//* 组件挂载初始化
onMounted(() => methods.init());
//* 组件卸载前, 移除loading
onBeforeUnmount(() => watchs?.stop());
</script>
